import { gql, type TypedDocumentNode } from '@apollo/client';
import { graphql } from '@newfront-insurance/graphql-frontend';

export interface SkillShareGroup {
  uuid: string;
  name: string;
  description: string | null;
  parentGroupUuid: string | null;
  isOrganization: boolean;
}

// The local BFF exposes organization metadata ahead of the generated stage schema.
export const GET_CUSTOM_SKILL_GROUP_SHARES: TypedDocumentNode<
  { getCustomSkillGroupAssignments: { __typename?: 'CustomSkillGroupAssignments'; groups: SkillShareGroup[] } },
  { skillUuid: string }
> = gql`
  query NovaSettingsCustomSkillGroupShares($skillUuid: String!) {
    getCustomSkillGroupAssignments(skillUuid: $skillUuid) {
      groups {
        uuid
        name
        description
        parentGroupUuid
        isOrganization
      }
    }
  }
`;

export const SHARE_SETTINGS_CUSTOM_SKILL_WITH_GROUP = graphql(`
  mutation NovaSettingsShareCustomSkillWithGroup($skillUuid: String!, $groupId: String!) {
    group: shareCustomSkillWithGroup(skillUuid: $skillUuid, groupId: $groupId) {
      uuid
    }
  }
`);

export const UNSHARE_SETTINGS_CUSTOM_SKILL_FROM_GROUP = graphql(`
  mutation NovaSettingsUnshareCustomSkillFromGroup($skillUuid: String!, $groupId: String!) {
    group: unshareCustomSkillFromGroup(skillUuid: $skillUuid, groupId: $groupId) {
      uuid
    }
  }
`);
